import { dataMobileAppSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMobileAppSolid = /*#__PURE__*/createIcon(dataMobileAppSolid)
export default IconMobileAppSolid
